import { render, staticRenderFns } from "./ReplyExistingPropertyDivision.vue?vue&type=template&id=07aece13"
import script from "./ReplyExistingPropertyDivision.vue?vue&type=script&lang=ts"
export * from "./ReplyExistingPropertyDivision.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports